import Dropzone from "dropzone/dist/dropzone";
import {__} from "./libraries/translations.ts";

const {ActivityController} = require('./controllers/activity-controller.ts');

Dropzone.options.activityPhotoUploader = {
    paramName: 'photo',
    maxFilesize: 10,
    dictDefaultMessage: __('drop-files-here'),
    sending: function (file, xhr, formData) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr('content'));
        // Will send the filesize along with the file as POST data.
        formData.append('action', 'upload-photo');
        $('#activity-photo-uploader input[type=hidden]').each((index, element) => {
            formData.append($(element).attr('name'), $(element).val());
        });
    },
    queuecomplete: function () {
        $('.photos-uploaded-notice').show();
    }
};


$(document).ready(_ => {
    $('.message').each((index, el) => {
        const id = $(el).data('id');
        const editForm = $(el).find('form.edit-form[data-id=edit' + id + ']');
        const replyToForm = $(el).find('form.edit-form[data-id=replyTo' + id + ']');
        const message = $(el).find('.message-content[data-id=' + id + ']');

        $(el).find('button.edit-button[data-id=' + id + ']').click(_ => {
            editForm.show();
            message.hide();
        });

        $(el).find('button.reply-button[data-id=' + id + ']').click(_ => {
            replyToForm.show();
        });

        $(el).find('button.cancel-button').click(_ => {
            editForm.hide();
            replyToForm.hide();
            message.show();
        });
    });

    const searchForm = $('#shareInternalModal .users-search-form');
    const aContainer = $('#shareInternalModal .users-container');
    const aSelectionCounter = $('#shareInternalModal .user-selection-count');
    const aSelection2Counter = $('#shareInternal2Modal .user-selection-count');
    const aSelectionField = $('#shareInternalModal .user-selection');
    const aSelection2Field = $('#shareInternal2Modal .user-selection');
    const AC = new ActivityController(
        aContainer,
        searchForm,
        $('#shareInternalModal .pagination-options'),
        $('#shareInternalModal .paginator-container'),
        {},
        null,
        'users-for-activity'
    );
    AC.enableSelection((selection) => {
        aSelectionField.val(selection.join(','));
        aSelection2Field.val(selection.join(','));
        aSelectionCounter.html(selection.length);
        aSelection2Counter.html(selection.length);
    });

    if (aContainer.hasClass('reload-on-favorite')) {
        AC.onFavoriteClicked(() => {
            location.reload();
        });
    }

    $('.internal-invite-next').click(_ => {
        window.location.href = window.location.pathname + "?" + $.param({'invite-users': AC.selection.join(',')});
    });

    const enrollButton = $('#btnEnroll');
    if (/[?&]autoEnroll=/.test(location.search) && enrollButton) {
        enrollButton.trigger('click');
    }

    const money = (num) => {
        return '€' + parseFloat(num.toFixed(2)).toLocaleString('nl-NL', {useGrouping: true, minimumFractionDigits: 2});
    }

    const activityParticipationHelper = (_ => {
        return {
            guestCount: window.guestCount,
            participationCosts: window.participationCosts,
            participationSelection: window.participationSelection,
            optionDetails: window.activityOptions,
            costsBreakdown: null,
            init: (participateModal) => {
                const guestSelect = $(participateModal).find('select[name=guests]')
                $(guestSelect).change(function() {
                    // automatically update required options to be included for all guests
                    activityParticipationHelper.guestCount = +$(this).val();
                    activityParticipationHelper.update();
                });

                $(participateModal).find('.activity-option .option-amount-selector').change(function() {
                    activityParticipationHelper.participationSelection[$(this).data('index')] = {amount: +$(this).val()};
                    activityParticipationHelper.update();
                });

                $(participateModal).find('.activity-option .form-check-input').change(function() {
                    activityParticipationHelper.participationSelection[$(this).data('index')] = {amount: this.checked ? 1 : 0};
                    activityParticipationHelper.update();
                });

                activityParticipationHelper.costsBreakdownComponent = $(participateModal).find('#costs-breakdown');
                activityParticipationHelper.update();

                const termsHint = $(participateModal).find('div.terms-hint');
                const termsCheck = $(participateModal).find('input[name=accept]');
                $(participateModal).find('button[name=action]').click((e) => {
                    const acceptedTerms = $(termsCheck).is(':checked');
                    if(termsCheck.length > 0 && !acceptedTerms) {
                        e.preventDefault(); // prevents default
                        $(termsHint).show();
                        $(termsCheck).addClass('is-invalid');
                        return false;
                    }
                    return true;
                });

                $(participateModal).find('input[name=accept]').change(function(a) {
                    const acceptedTerms = $(this).is(':checked');
                    if(acceptedTerms) {
                        $(termsHint).hide();
                        $(termsCheck).removeClass('is-invalid');
                        return;
                    }
                    $(termsHint).show();
                    $(termsCheck).addClass('is-invalid');
                });
            },
            update: _ => {
                for(let selector of $('.activity-option[data-required=true] .option-amount-selector')) {
                    $(selector).val(activityParticipationHelper.guestCount + 1);
                    activityParticipationHelper.participationSelection[$(selector).data('index')] = {amount: activityParticipationHelper.guestCount + 1};
                }

                for(let selector of $('.activity-option[data-required=true] .form-check-input')) {
                    if(!($(selector).data('index') in activityParticipationHelper.participationSelection)) {
                        activityParticipationHelper.participationSelection[$(selector).data('index')] = {amount: 1};
                    }
                }

                const message = [];
                let totalPrice = 0;
                for(let index in activityParticipationHelper.participationSelection) {
                    const selection = activityParticipationHelper.participationSelection[index];
                    if(selection.amount <= 0) {
                        continue;
                    }
                    const details = activityParticipationHelper.optionDetails[index];
                    message.push(
                        [
                            selection.amount + ' x ' + details.name + ' à ' + money(details.costs),
                            '+ ' + money(selection.amount * details.costs)
                        ]
                    );
                    totalPrice+= selection.amount * details.costs;
                }

                let html = '<table style="width:100%"><tr><td colspan="2"><strong>Totaalbedrag:</strong></td></tr>';
                html+=message.map(line => '<tr><td>'+line[0]+'</td><td>'+line[1]+'</td></tr>').join('');
                html+='<tr><td></td><td><strong>Totaal: ' + money(totalPrice) + '</strong></td></tr></table>';

                $(activityParticipationHelper.costsBreakdownComponent).html(html);
            }
        };
    })();

    const participateModal = $('#participate-select-options-modal');
    if (participateModal) {
        activityParticipationHelper.init(participateModal);
    }
});
